// extracted by mini-css-extract-plugin
export default {"player":"Video_player__ZYSNg","reactPlayer":"Video_reactPlayer__lPdI0"};